import { SadPage } from "../../../components/SadPage"

export function NotFoundPage() {
  return (
    <SadPage
      lines={[
        "The page you're looking for doesn't exist.",
        "Please check the URL and try again.",
      ]}
    />
  )
}
